import React from 'react'
import PropTypes from 'prop-types'


const Subtitle = ({ text, classList }) => <h3 className={classList}>{text}</h3>

Subtitle.prototype = {
  text: PropTypes.string.isRequired,
  classList: PropTypes.string.isRequired,
}
export default Subtitle;